import "./ticket.css";
import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Empty, Spin } from "antd";
import { PageHeader } from "@ant-design/pro-layout";
import moment from "moment";
import CustomBreadcrumb from "../../../components/CustomBreadcrumb";
import { useTranslation } from "react-i18next";
import { EyeOutlined, HomeOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import ReactToPrint from "react-to-print";

const PrintTicket = () => {
  const [ticketsData, setTicketsData] = useState([]);
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();
  const ticketRef = useRef();
  const { state } = useLocation();

  useEffect(() => {
    setLoading(true);
    setTicketsData(Array.isArray(state?.tickets) ? state.tickets : []);
    setLoading(false);
  }, [state]);

  const breadcrumbRoutes = [
    {
      path: "/",
      breadcrumbName: t("home"),
      icon: <HomeOutlined />,
    },
    {
      path: "print-ticket",
      breadcrumbName: t("print_ticket"),
      icon: <EyeOutlined />,
    },
  ];

  return (
    <div className="app-relative">
      <Card className="app-mb-20">
        <CustomBreadcrumb menus={breadcrumbRoutes} />
        <PageHeader
          title={t("print_ticket")}
          ghost={false}
          className="app-p-0"
          extra={[
            <ReactToPrint
              key="print"
              trigger={() => <Button type="primary">{t("print")}</Button>}
              content={() => ticketRef.current} // print wrapper
            />,
          ]}
        />
      </Card>

      <Spin spinning={loading}>
        <div ref={ticketRef} className="tickets-wrapper">
          {ticketsData.length > 0 ? (
            ticketsData.map((ticket) => (
              <Card
                key={ticket.id || `${ticket.transaction_id}-${ticket.product_id}`}
                style={{
                  border: "1px solid var(--color-border)",
                  borderRadius: "10px",
                  textAlign: "center",
                  pageBreakInside: "avoid", // ✅ ensures each card prints cleanly
                }}
              >
                <h2 style={{ margin: "4px 0", fontWeight: "bold" }}>
                  {ticket.product?.name_en || "-"}
                </h2>
                <h2 style={{ margin: "4px 0", fontWeight: "bold" }} dir="rtl">
                  {ticket.product?.name || "-"}
                </h2>

                <div
                  style={{
                    fontSize: "13px",
                    color: "var(--color-text)",
                    marginBottom: "6px",
                  }}
                >
                  {ticket.created_at
                    ? moment(ticket.created_at).format("MMM. D, YYYY")
                    : "-"}
                  {" - "}
                  {ticket.expiry_date
                    ? moment(ticket.expiry_date).format("MMM. D, YYYY")
                    : "-"}
                </div>

                <div
                  style={{
                    fontSize: "15px",
                    fontWeight: "500",
                    marginBottom: "6px",
                  }}
                >
                  {ticket.total_quantity || 0}{" "}
                  {ticket.total_quantity > 1
                    ? t("person_other")
                    : t("person_one")}
                </div>

                {ticket.transaction && (
                  <div
                    style={{
                      marginBottom: "10px",
                      fontSize: "13px",
                      color: "var(--color-heading)",
                    }}
                  >
                    {ticket.transaction.uid}
                  </div>
                )}

                {ticket.qr_code_path && (
                  <img
                    src={`data:image/png;base64,${ticket.qr_code_path}`}
                    alt={t("qr")}
                    style={{
                      width: "120px",
                      margin: "10px auto",
                      display: "block",
                    }}
                  />
                )}

                <small
                  style={{
                    display: "block",
                    marginTop: "10px",
                    color: "var(--color-text-muted)",
                    fontSize: "12px",
                  }}
                >
                  {t("printed_by_anypos")}
                </small>
              </Card>
            ))
          ) : (
            <p>
              <Empty />
            </p>
          )}
        </div>
      </Spin>
    </div>
  );
};

export default PrintTicket;
